import { secureStorage, StorageKeys } from "@services/secureStorage.service";
import i18n from "assets/i18n";

export function setInterceptor(headers: Headers, api: any ) {
  const clientId = secureStorage.get<string>(StorageKeys.CLIENT_ID) || "";
  const token = secureStorage.get<string>(StorageKeys.JWT) || "";
  if (!api.arg.url.includes("elmagico")){
    headers.set("ProgramGroupKey", clientId.toString());
  }
  
  headers.set("Accept-Language", i18n.language === "ar" ? "ar-EG" : "en-US");
  headers.set("Authorization", `Bearer ${token}`);
  return headers;
}
